<template>
  <div
    v-if="shouldShowBar"
    class="row no-gutters justify-content-center pb-3 mt-3"
  >
    <div
      class="col-12 text-center"
    >
      <span>{{ currentWidth }}</span>
    </div>

    <div class="col-12 progress progress-styling rounded-pill">
      <div
        class="progress-bar progress-bar lead-channel-primary-background-color rounded-pill"
        role="progressbar"
        :style="{width: currentWidth}"
        :aria-valuenow="loadingPercent"
        aria-valuemin="0"
        aria-valuemax="100"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    computed: {
      ...mapGetters({
        displayMode: 'global/displayMode',
        loadingPercent: 'global/loadingPercent'
      }),
      currentWidth () {
        return `${this.loadingPercent}%`;
      },
      shouldShowBar () {
        return this.$route.path !== '/thanks';
      }
    }
  };
</script>

<style lang="scss" scoped>
  .progress-styling {
    max-width: 70%;
  }
</style>
